import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  readonly endpoint = 'log/';

  constructor(
    private api: ApiService
  ) { }

  public log(level: string, message: string): Observable<any> {
    return this.api.post(this.endpoint, {
      Message: message,
      LogLevel: level
    });
  }

  public trace(message: string) {
    return this.log('Trace', message);
  }

  public debug(message: string) {
    return this.log('Debug', message);
  }

  public info(message: string) {
    return this.log('Info', message);
  }

  public warn(message: string) {
    return this.log('Warn', message);
  }

  public error(message: string) {
    return this.log('Error', message);
  }

  public fatal(message: string) {
    return this.log('Fatal', message);
  }
}
